import styled from "styled-components";
import { units } from "@m/alchemy-theme";
import { Label } from "../field-label/FieldLabel.styled";
export const DateRangePicker = styled.div `
  display: inline-flex;
  max-width: 100%;
  width: 624px;
  align-items: flex-start;
  flex-wrap: wrap;

  > * {
    flex-basis: 50%;
    flex-grow: 1;
    margin: 0 0 ${units(1)} 0;
    /* IE 11 cannot have padding on direct flex children, so we moved it to the label */
    ${Label} {
      padding-left: ${units(2)};
    }

    input {
      min-width: 140px;
    }
  }

  margin: 0 0 ${units(-1)} ${units(-2)};
`;
export const DateRangePickerPopperWrapper = styled.div `
  [data-popper-placement^="top"] & {
    min-height: 400px;
  }
`;
